






































import { Vue, Component, Prop } from 'vue-property-decorator'
import { newPersionList, demandChart } from '@/api/newPersion'
import { CommonMudule } from '@/store/modules/common'
// import { optBtnList } from '../utils'
// import { BtnList } from '@/types/common/btn'
import { DemandChart } from '@/types/newPersion'
import { PonitXY, BaseBarCfg2 } from '@/types/common/g2Charts'
import BarChart from '@/components/g2Charts/chartList/barChart'
import { comdify2 } from '@/utils/validate'
import TsTable from '@/components/TsTable/TsTable.vue'
import { maxNumber } from '@/utils/baseFn'
import NewFooter from '@/views/newPension/components/newFooter'
@Component({
  components: { BarChart, TsTable, NewFooter },
})
export default class OutputPage extends Vue {
  @Prop({ default: true }) propTableShow!: boolean
  form = {};
  tableShow = this.propTableShow;
  downloadStatus = true;
  gapAmount = '';
  // btnList = optBtnList;
  chartOptions: BaseBarCfg2 = {
    position: [],
    titleNextContent: '岁',
    annotationContent: '单位:元',
    tooltipContext: '当年养老金需求（元）',
  };

  chartData: PonitXY[] = [];
  tableData: {data: DemandChart[]} = {
    data: [],
  };

  tableTitleObj = {
    title: '',
    options: {
      dropdown: false,
    },
  };

  tableHead = [
    {
      propName: 'age',
      labelName: '年龄',
    },
    {
      propName: 'demandAmount',
      labelName: '当年需求资金(元)',
    },
    {
      propName: 'discountedAmount',
      labelName: '折现至退休年-按保证利率3.5%(元)',
    },
  ];

  mounted () {
    this.getData()
  }

  private async getData () {
    // const res = await Promise.all([
    //   await getNewPersionList(),
    //   await getDemandChart(),
    // ])
    const customerIdObj = { customerId: CommonMudule.customerId }
    const res = await Promise.all([
      await newPersionList(customerIdObj),
      await demandChart(customerIdObj),
    ])
    if (res[0]?.data) {
      this.form = res[0].data
    }
    if (res[1]?.data) {
      const _chartData: PonitXY[] = []
      const _tableData: DemandChart[] = []
      const { pensionDemands, gapAmount } = res[1].data
      this.gapAmount = gapAmount
      pensionDemands.forEach((item: DemandChart) => {
        _chartData.push({
          x: item.age,
          y: item.demandAmount,
        })
        _tableData.push({
          age: item.age,
          demandAmount: comdify2(item.demandAmount),
          discountedAmount: comdify2(item.discountedAmount)
        })
      })
      this.chartOptions.position = [+_chartData[0].x, comdify2(maxNumber(pensionDemands, 'demandAmount') + '')]
      this.chartData = _chartData
      this.tableData.data = _tableData
    }
  }

  private handleShowTable () {
    this.tableShow = !this.tableShow
    this.downloadStatus = false
  }
}
